import { ViewAllSponsorsModal } from './ViewAllSponsorsModal'
import { withViewAllSponsorsModal } from './withViewAllSponsorsModal'

const ConnectedViewAllSponsorsModal =
  withViewAllSponsorsModal(ViewAllSponsorsModal)

export { ConnectedViewAllSponsorsModal as ViewAllSponsorsModal }
